import React from 'react';

export default function NotFound() {
  return (
    <>
      <div className='login d-flex flex-column align-items-center'>
        <h4 className='text-light'>Página não encontrada</h4>
      </div>
    </>
  );
}